"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundScreen = void 0;
var react_1 = __importDefault(require("react"));
var NotFoundScreen = function (props) {
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement("div", { className: "" }, "Not Found")));
};
exports.NotFoundScreen = NotFoundScreen;
